import evmProvider from "./evmProvider";

export const getWalletProvider = (provider, uiConsole) => {
  return evmProvider(provider, uiConsole);
};
